import { Component, OnInit, ElementRef, Renderer2 } from '@angular/core';

enum InputTypes {
  password = 'password',
  text = 'text'
}

@Component({
  selector: 'tp-show-hide-password',
  templateUrl: './show-hide-password.component.html',
  styleUrls: ['./show-hide-password.component.scss']
})
export class ShowHidePasswordComponent implements OnInit {
  input: HTMLInputElement;
  isHidden: boolean;

  constructor(private elem: ElementRef, private renderer: Renderer2) {}

  ngOnInit(): void {
    this.input = this.elem.nativeElement.querySelector('input');
    if (this.input) {
      this.isHidden = this.input.type === InputTypes.password;
    }
  }

  toggle(): void {
    this.isHidden = !this.isHidden;
    const typeToSet = this.isHidden ? InputTypes.password : InputTypes.text;
    this.renderer.setAttribute(this.input, 'type', typeToSet);
  }
}
